var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTreesMini = function SvgTreesMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#28C382"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M15.853 8.58a3.86 3.86 0 0 0-7.706 0 4.247 4.247 0 0 0 3.186 7.86v1.96a.667.667 0 1 0 1.334 0v-1.96a4.247 4.247 0 0 0 3.186-7.86ZM14 15.333a2.9 2.9 0 0 1-1.333-.326V13.6a.666.666 0 1 0-1.334 0v1.413A2.9 2.9 0 0 1 10 15.34a2.926 2.926 0 0 1-.96-5.7.667.667 0 0 0 .44-.667 1.054 1.054 0 0 0 0-.173 2.54 2.54 0 1 1 5.073.033.991.991 0 0 0 0 .14.666.666 0 0 0 .44.667A2.927 2.927 0 0 1 14 15.333Z"
  })));
};
export default SvgTreesMini;